import React from "react";
import "./loan-step.css";
import { CheckCircle2, FileText, UserCheck, Wallet } from "lucide-react";

export default function LoanStep() {
  const steps = [
    {
      id: 1,
      title: "Apply Online",
      desc: "Complete a quick online application with your basic personal and financial details — simple and secure.",
      icon: <FileText size={38} />,
      color: "#1ab69d",
    },
    {
      id: 2,
      title: "Verify Details",
      desc: "Our experts securely verify your documents and eligibility through a fast, fully digital process.",
      icon: <UserCheck size={38} />,
      color: "#ff8b34",
    },
    {
       id: 3,
    title: "Get Approval",
    desc: "Once verified, receive instant approval with a customized loan offer — no unnecessary delays or hidden conditions.",
    icon: <CheckCircle2 size={38} />,
    color: "#3f51b5",
  },
    {
      id: 4,
      title: "Money Disbursed",
      desc: "After approval, the sanctioned amount is disbursed promptly to your bank account with complete transparency.",
      icon: <Wallet size={38} />,
      color: "#ee4a62",
    },
  ];

  return (
    <section className="loan-step-section">
      <div className="loan-step-bg"></div>
      <div className="container">

          <h2 className="loan-step-title mb-4">
              How to Get  <span className="highlight">Your Ultra Short Term Loan in</span> 4 Easy Steps
            </h2>
        <p className="loan-step-subtitle">
          Follow these simple steps to get your loan approved quickly and hassle-free.
        </p>

        <div className="steps-wrapper">
          {steps.map((step, index) => (
            <div
              className="step-card animate-step"
              key={step.id}
              style={{ animationDelay: `${index * 0.2}s` }}
            >
              <div
                className="step-icon"
                style={{ backgroundColor: step.color }}
              >
                {step.icon}
              </div>

              <h4>{step.title}</h4>
              <p>{step.desc}</p>

              {index < steps.length - 1 && (
                <div className="step-connector">
                  <span className="line"></span>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
